import React, { useContext } from "react";
import { computeScale } from "../helpers/scale";
import { xExtendContext, yExtendContext, y2ExtendContext, } from "../ExtendHandler";
export const ScaleContext = React.createContext({
    yScale: undefined,
    xScale: undefined,
    y2Scale: undefined,
});
export const GraphSettingsContainerWrapper = ({ data, allAxisConfig, allValues, objects, svgDimensions, isHistogram, margins, elements, allApplyPadding, children, }) => {
    const xExtend = useContext(xExtendContext);
    const yExtend = useContext(yExtendContext);
    const y2Extend = useContext(y2ExtendContext);
    const allExtendsConfig = {
        x: xExtend,
        y: yExtend,
        y2: y2Extend,
    };
    const scales = Object.keys(allAxisConfig).reduce((scalesObject, currentAxis) => {
        if (!allAxisConfig[currentAxis]) {
            return scalesObject;
        }
        const currentAxisConfig = allAxisConfig[currentAxis];
        const currentAxisValues = allValues[currentAxis];
        const currentAxisExtends = allExtendsConfig[currentAxis].extend;
        const currentApplyPadding = allApplyPadding[currentAxis];
        const currentScale = computeScale(data, currentAxisValues, currentAxisConfig, margins, svgDimensions, currentAxisExtends, objects, currentApplyPadding, elements, isHistogram);
        return Object.assign(Object.assign({}, scalesObject), { [`${currentAxis}Scale`]: currentScale });
    }, {});
    const parsedExtends = Object.keys(allExtendsConfig).reduce((extendsObject, currentAxis) => {
        if (!(currentAxis in allExtendsConfig)) {
            return extendsObject;
        }
        const currentExtend = allExtendsConfig[currentAxis];
        return Object.assign(Object.assign({}, extendsObject), { [`${currentAxis}Extend`]: currentExtend });
    }, {});
    return (React.createElement(ScaleContext.Provider, { value: Object.assign(Object.assign({}, scales), parsedExtends) }, children));
};
//# sourceMappingURL=GraphSettingsContainer.js.map